export default {
  title: 'Política de Privacidade',
  lastUpdated: 'Última atualização: 27 de novembro de 2025',
  section1: {
    title: '1. Introdução',
    content: 'Bem-vindo ao UmiGo. Respeitamos sua privacidade e estamos comprometidos em proteger seus dados pessoais. Esta política de privacidade informará como cuidamos de seus dados pessoais quando você usa nosso aplicativo móvel e site, e informará sobre seus direitos de privacidade e como a lei o protege.'
  },
  section2: {
    title: '2. Informações que Coletamos',
    intro: 'Coletamos e processamos os seguintes tipos de informações:',
    items: [
      '<strong>Informações da Conta:</strong> Nome de usuário, endereço de e-mail, número de telefone, data de nascimento, gênero e foto de perfil',
      '<strong>Dados do Perfil:</strong> Biografia, interesses, preferências e configurações que você configura',
      '<strong>Conteúdo:</strong> Mensagens, fotos, vídeos, gravações de voz e outro conteúdo que você cria ou compartilha',
      '<strong>Dados de Uso:</strong> Informações sobre como você usa nossos serviços, incluindo recursos acessados, tempo gasto e interações',
      '<strong>Informações do Dispositivo:</strong> Tipo de dispositivo, sistema operacional, identificadores únicos do dispositivo, informações de rede móvel',
      '<strong>Dados de Localização:</strong> Localização aproximada baseada no endereço IP ou localização precisa se você conceder permissão',
      '<strong>Informações de Pagamento:</strong> Detalhes do cartão de pagamento e histórico de transações para compras no aplicativo',
      '<strong>Comunicações:</strong> Interações de suporte ao cliente e feedback que você fornece'
    ]
  },
  section3: {
    title: '3. Como Usamos suas Informações',
    intro: 'Usamos suas informações para:',
    items: [
      'Fornecer, manter e melhorar nossos serviços',
      'Criar e gerenciar sua conta',
      'Permitir comunicação entre usuários através de recursos de mensagens, voz e vídeo',
      'Personalizar sua experiência e fornecer recomendações de conteúdo',
      'Processar transações e enviar informações relacionadas',
      'Enviar avisos técnicos, atualizações, alertas de segurança e mensagens de suporte',
      'Responder a seus comentários, perguntas e solicitações de atendimento ao cliente',
      'Monitorar e analisar tendências, uso e atividades',
      'Detectar, prevenir e resolver problemas técnicos, fraude e atividades ilegais',
      'Cumprir obrigações legais e fazer cumprir nossos termos'
    ]
  },
  section4: {
    title: '4. Compartilhamento e Divulgação de Informações',
    intro: 'Podemos compartilhar suas informações nas seguintes circunstâncias:',
    items: [
      '<strong>Com Outros Usuários:</strong> Suas informações de perfil e conteúdo que você compartilha são visíveis para outros usuários de acordo com suas configurações de privacidade',
      '<strong>Provedores de Serviços:</strong> Empresas terceirizadas que nos ajudam a operar nossos serviços (hospedagem, análise, processamento de pagamentos, suporte ao cliente)',
      '<strong>Transferências Comerciais:</strong> Em conexão com qualquer fusão, venda de ativos da empresa, financiamento ou aquisição',
      '<strong>Requisitos Legais:</strong> Quando exigido por lei ou para proteger direitos, propriedade ou segurança',
      '<strong>Com seu Consentimento:</strong> Quando você concorda explicitamente em compartilhar informações com terceiros'
    ],
    note: 'Não vendemos suas informações pessoais a terceiros para fins de marketing.'
  },
  section5: {
    title: '5. Segurança de Dados',
    intro: 'Implementamos medidas técnicas e organizacionais apropriadas para proteger seus dados pessoais contra acesso não autorizado, alteração, divulgação ou destruição. Isso inclui:',
    items: [
      'Criptografia de ponta a ponta para mensagens privadas',
      'Transmissão segura de dados usando protocolos SSL/TLS',
      'Avaliações e atualizações de segurança regulares',
      'Controles de acesso e mecanismos de autenticação',
      'Treinamento de funcionários sobre práticas de proteção de dados'
    ]
  },
  section6: {
    title: '6. Retenção de Dados',
    content: 'Retemos seus dados pessoais apenas pelo tempo necessário para cumprir os propósitos descritos nesta política de privacidade, a menos que um período de retenção mais longo seja exigido por lei. Quando você excluir sua conta, excluiremos ou anonimizaremos seus dados pessoais dentro de 90 dias, exceto quando precisarmos retê-los para conformidade legal ou propósitos comerciais legítimos.'
  },
  section7: {
    title: '7. Seus Direitos de Privacidade',
    intro: 'Dependendo da sua localização, você pode ter os seguintes direitos:',
    items: [
      '<strong>Acesso:</strong> Solicitar acesso aos seus dados pessoais',
      '<strong>Correção:</strong> Solicitar correção de dados imprecisos ou incompletos',
      '<strong>Exclusão:</strong> Solicitar exclusão de seus dados pessoais',
      '<strong>Portabilidade:</strong> Solicitar transferência de seus dados para outro serviço',
      '<strong>Objeção:</strong> Objetar ao processamento de seus dados pessoais',
      '<strong>Restrição:</strong> Solicitar restrição de processamento',
      '<strong>Retirar Consentimento:</strong> Retirar consentimento a qualquer momento quando dependemos do consentimento'
    ],
    note: 'Para exercer esses direitos, entre em contato conosco em privacy@umigo.cc'
  },
  section8: {
    title: '8. Privacidade de Crianças',
    content: 'O UmiGo não se destina a usuários menores de 13 anos (ou 16 em certas jurisdições). Não coletamos intencionalmente informações pessoais de crianças. Se tomarmos conhecimento de que uma criança nos forneceu dados pessoais, tomaremos medidas para excluir essas informações. Se você acredita que coletamos informações de uma criança, entre em contato conosco imediatamente.'
  },
  section9: {
    title: '9. Transferências Internacionais de Dados',
    content: 'Suas informações podem ser transferidas e processadas em países diferentes do seu país de residência. Esses países podem ter leis de proteção de dados diferentes. Garantimos que salvaguardas apropriadas estejam em vigor para proteger seus dados pessoais de acordo com esta política de privacidade.'
  },
  section10: {
    title: '10. Cookies e Tecnologias de Rastreamento',
    content: 'Usamos cookies e tecnologias de rastreamento semelhantes para coletar e rastrear informações sobre seu uso de nossos serviços. Você pode controlar cookies através das configurações do seu navegador, mas desabilitar cookies pode afetar sua capacidade de usar certos recursos.'
  },
  section11: {
    title: '11. Links e Serviços de Terceiros',
    content: 'Nossos serviços podem conter links para sites ou serviços de terceiros. Não somos responsáveis pelas práticas de privacidade desses terceiros. Recomendamos que você leia suas políticas de privacidade antes de fornecer qualquer informação.'
  },
  section12: {
    title: '12. Alterações a esta Política de Privacidade',
    content: 'Podemos atualizar esta política de privacidade de tempos em tempos. Notificaremos você sobre quaisquer alterações publicando a nova política de privacidade nesta página e atualizando a data de "Última atualização". O uso continuado de nossos serviços após as alterações constitui aceitação da política atualizada.'
  },
  section13: {
    title: '13. Entre em Contato',
    intro: 'Se você tiver alguma dúvida sobre esta política de privacidade ou nossas práticas de privacidade, entre em contato conosco:',
    email: '<strong>E-mail:</strong> privacy@umigo.cc',
    phone: '<strong>Telefone:</strong> WA: +52 8 132724843',
    address: '<strong>Endereço:</strong> Av. Paseo de la Reforma 222, Ciudad de México, CDMX 06600, México'
  },
  regional: {
    title: 'Informações de Privacidade Regional',
    ccpa: {
      title: 'Para Residentes da Califórnia (CCPA)',
      intro: 'Os residentes da Califórnia têm direitos adicionais sob a Lei de Privacidade do Consumidor da Califórnia (CCPA):',
      items: [
        'Direito de saber quais informações pessoais são coletadas, usadas, compartilhadas ou vendidas',
        'Direito de excluir informações pessoais',
        'Direito de optar por não participar da venda de informações pessoais',
        'Direito à não discriminação por exercer os direitos da CCPA'
      ]
    },
    gdpr: {
      title: 'Para Usuários Europeus (GDPR)',
      content: 'Se você estiver localizado no Espaço Econômico Europeu (EEE), você tem direitos sob o Regulamento Geral de Proteção de Dados (GDPR), incluindo o direito de acessar, retificar, apagar, restringir o processamento, portabilidade de dados e se opor ao processamento de seus dados pessoais.'
    }
  }
};
